module.exports = __webpack_public_path__ + "img/login-logo.835a94e6.png";